import coreRoutes from '@glittr/frontend-core/src/routes';
import Home from './views/pages/index.vue';

export default {
  mode: 'history',
  base: process.env!.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/_admin/redebits',
      name: 'redebits',
      component: () => import('./views/pages/redebits/list.vue'),
    },
    {
      path: '/_admin/redebits/upload',
      name: 'upload',
      component: () => import('./views/pages/redebits/upload.vue'),
    },
    {
      path: '/_admin/redebits/:id',
      name: 'redebit',
      component: () => import('./views/pages/redebits/detail.vue'),
    },
    ...coreRoutes,
    {
      path: '/:tenant/:workspace',
      name: 'dashboard',
      component: () => import('./views/pages/app/dashboard.vue'),
    },
  ],
};
